import { Component, OnInit } from '@angular/core';
import { GridAuditUserService } from '@shared/services/audit-service/grid-audit-user.service';
import { SearchAuditRecordService } from '@shared/services/audit-service/search-audit-record.service';
import { SearchAuditUserService } from '@shared/services/audit-service/search-audit-user.service';
import { gridAuditHeadersMap } from '@official/utils/mappers/audit-mapper';
import { GridTypeEnum, gridTableheadersMap } from '@official/utils/mappers/grid-mapper';
import { IAuditModel, IAuditPanelInfo } from '@shared/models/audit.model';
import { Breadcrumb } from '@types-custom/models/ui/breadcrumb-model';
import { Icon } from '@types-custom/models/ui/icon-model';

@Component({
  selector: 'manage-audit',
  templateUrl: './manage-audit.component.html',
  styleUrls: ['./manage-audit.component.scss'],
})
export class ManageAuditComponent implements OnInit {

  Icon = Icon;
  icon = Icon.manage_accounts_w;
  funcionalidades: any[] = [];
  selectedFunctionality: string;
  renderTab = true;
  propertiesPanelAuditInfo: IAuditPanelInfo;
  modelAudit: IAuditModel = {
    renderPrincipal: true
  };

  constructor(
    public searchAuditUserService: SearchAuditUserService,
    public searchAuditRecordService: SearchAuditRecordService,
    public gridAuditUserService: GridAuditUserService,
  ) {
  }

  ngOnInit(): void {
    this.getAuditType();
  }

  getAuditType() {
    this.renderTab = false;
    this.gridAuditUserService
      .getAuditType()
      .subscribe({
        next: (data: Array<any>) => {
          this.funcionalidades = data;
          this.selectedFunctionality = this.funcionalidades[0].code;
          this.searchAuditUserService.setModelAudit({
            code: this.selectedFunctionality
          });
          this.searchAuditRecordService.setModelAudit({
            code: this.selectedFunctionality
          });
          this.renderTab = true;
        },
      });
  }

  onSelectFunctionality(): void {
    this.renderTab = false;
    setTimeout(() => {
      this.searchAuditUserService.setModelAudit({
        code: this.selectedFunctionality
      });
      this.searchAuditRecordService.setModelAudit({
        code: this.selectedFunctionality
      });
      this.renderTab = true;
    }, 1);
  }

  manageEvent($event: any) {
    this.modelAudit = $event;
    this.selectedFunctionality = this.modelAudit.code;
    if (this.modelAudit.renderAuditPanel) {

      this.propertiesPanelAuditInfo = {
        model: {
          code: this.selectedFunctionality
        },
        headersMain: gridTableheadersMap([null])[GridTypeEnum.ManageGridUserAudit],
        dataMain: this.modelAudit.data,
        headersBody: gridAuditHeadersMap()[this.selectedFunctionality],
        dataBody: this.modelAudit?.dataAux
      };
    }

    let routes: Breadcrumb[] = $event.routes;

    if (routes == undefined) {
      routes = [{
        label: 'Auditoria',
        url: 'principal'
      }];
    }

    this.modelAudit.routes = routes;
  }

  navigateToVisor(): void {
    // this.router.navigate([RouteNamesEnum.MapViewer]);
  }
}
